import { render, staticRenderFns } from "./NormalSearchNav152.vue?vue&type=template&id=0bc7785c&scoped=true&"
import script from "./NormalSearchNav152.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav152.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc7785c",
  null
  
)

export default component.exports